(app => {

    app.service("contactsDataTable",
        [
            "modalService", "personApi", function (modalService, personApi) {
                this.dataTableOptions = {
                    title: "Contacts"
                };

                this.buildDataTableOptions = (contacts, currentUser) => {
                    this.dataTableOptions = {
                        ...this.dataTableOptions,
                        headers: this.getHeaders(),
                        rows: contacts.map(contact => {
                            return {
                                cells: [
                                    this.capitalize(contact.Name),
                                    contact.PrimaryPhoneNumber,
                                    contact.PrimaryEmailAddress,
                                    contact.Status
                                ],
                                rowObject: contact,
                                state: {
                                    name: "Home.Client",
                                    params: { clientId: contact.Id }
                                },
                                rowActions: []
                            };
                        }),
                        filters: [
                            {
                                index: 3,
                                label: "Status",
                                options: this.getStatusFilters(contacts)
                            }
                        ],
                        rowActions: [
                            {
                                title: "Delete contact",
                                iconName: "mdi-delete",
                                className: "btn-warning",
                                action: this.deleteContact
                            }
                        ],
                        miscButtons: [
                            {
                                label: "Import Contacts from Excel",
                                action: this.importContacts,
                                params: [
                                    currentUser
                                ],
                                ampEvent: {
                                    Value: true,
                                    Type: "Click",
                                    Name: "Import Contacts Modal"
                                }
                            },
                            {
                                label: "Add New Contact",
                                action: this.addContact,
                                params: [
                                    currentUser
                                ]
                            }
                        ]
                    };

                    return this.dataTableOptions;
                };

                this.getHeaders = () => {
                    return [
                        {
                            title: "Name",
                            type: "string"
                        },
                        {
                            title: "Phone Number",
                            type: "phoneNumber"
                        },
                        {
                            title: "Email Address",
                            type: "string"
                        },
                        {
                            title: "Status",
                            type: "string"
                        }
                    ];
                };

                this.capitalize = (text) => {
                    if (typeof text !== 'string') return '';
                    return text.replace(/^(.)|\s(.)/g,  (v) => { return v.toUpperCase(); });
                };

                this.removeDuplicateObjects = (arr) => {
                    return arr.filter((obj, index, self) => {
                        return index === self.findIndex(o => o.label === obj.label);
                    });
                };

                this.getStatusFilters = (contacts) => {
                    let statuses = contacts.map(contact => {
                        return {
                            selected: false,
                            label: contact.Status
                        };
                    });

                    return this.removeDuplicateObjects(statuses);
                };

                this.deleteContact = (contact, $event) => {
                    modalService.confirmDeleteClient($event).then(() => {
                        const index = this.dataTableOptions.rows.findIndex(row => {
                            return row.rowObject.Id === contact.Id;
                        });

                        this.dataTableOptions.rows.splice(index, 1);
                        personApi.delete(contact.Id);
                    });
                };

                this.addContact = ($event, params) => {
                    modalService.openAddContact(params[0], $event);
                };

                this.importContacts = ($event, params) => {
                    modalService.openImportContacts(params[0], $event);
                };
            }
        ]);

})(window.app);